import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// API helper methods
import {
  sendOverdueEmailApi,
  sendReminderEmailApi,
} from "../../helpers/fakebackend_helper";

export const sendOverdueEmail = createAsyncThunk(
  "email/sendOverdueEmail",
  async (emailData, { rejectWithValue }) => {
    console.log(emailData);
    try {
      const response = await sendOverdueEmailApi(emailData);
      console.log(response);

      if (response.status === 429) {  // Handle too many requests (email already sent)
        toast.info(`Overdue email already sent for PVC ${emailData.pvc_number} in the last 24 hours`, { autoClose: 1500 });
        return rejectWithValue({ alreadySent: true, pvc_number: emailData.pvc_number });
      }

      toast.success(`Overdue payment email sent for PVC ${emailData.pvc_number}`, { autoClose: 1000 });
      return response.data;  // Return only the response data
    } catch (error) {
      console.log(error)
      const errorMessage = error.message || "Error sending email";

      if (error.status === 429) {
        toast.info(`Overdue email already sent for PVC ${emailData.pvc_number} in the last 24 hours`, { autoClose: 1500 });
        return rejectWithValue({ alreadySent: true, pvc_number: emailData.pvc_number });
      }

      toast.error(`Failed to send overdue payment email for PVC ${emailData.pvc_number}`, { autoClose: 1000 });
      return rejectWithValue({ error: errorMessage });
    }
  }
);

export const sendReminderEmail = createAsyncThunk(
  "email/sendReminderEmail",
  async (emailData, { rejectWithValue }) => {
    console.log(emailData);
    try {
      const response = await sendReminderEmailApi(emailData);
      console.log(response);

      if (response.status === 429) {  // Handle too many requests (email already sent)
        toast.info(`Reminder email already sent for PVC ${emailData.pvc_number} in the last 24 hours`, { autoClose: 1500 });
        return rejectWithValue({ alreadySent: true, pvc_number: emailData.pvc_number });
      }

      toast.success(`Reminder payment email sent for PVC ${emailData.pvc_number}`, { autoClose: 1000 });
      return response.data;  // Return only the response data
    } catch (error) {
      const errorMessage = error.message || "Error sending email";

      if (error.status === 429) {
        toast.info(`Reminder email already sent for PVC ${emailData.pvc_number} in the last 24 hours`, { autoClose: 1500 });
        return rejectWithValue({ alreadySent: true, pvc_number: emailData.pvc_number });
      }

      toast.error(`Failed to send reminder payment email for PVC ${emailData.pvc_number}`, { autoClose: 1000 });
      return rejectWithValue({ error: errorMessage });
    }
  }
);
